import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';

import reducers from './redux/reducers';
import Routes from './Routes';
import { init as firebaseinit } from './Firebase'

import './static/scss/index.scss'

class App extends Component {

  render() {
    firebaseinit()
    const store = createStore(reducers, {}, applyMiddleware(ReduxThunk));
    return (
      <Provider store={store}>
        <Routes />
      </Provider>
    );
  }
}

export default App;
